/** 抽奖活动编号常量 */

/** D5 — 超级生日赏 */
export const LOTTERY_CODE_D5 = "D5";

/** 周年活动批量登记及二维码核销使用的活动标识 */
export const ANNIVERSARY_ACTIVITY_KEY = "lottery-anniversary-2026";
